// extracted by mini-css-extract-plugin
export default {"navWrapper":"styles_navWrapper__0BMGV","container":"styles_container__m+3Q0","navigation":"styles_navigation__Y2YcZ","active":"styles_active__+vahX"};